import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";

const MarketDetailsList = (props) => {
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const [deleteLoading, setDeleteLoading] = useState(false);

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, marketDetailId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Market detail?",
      onOk() {
        setDeleteLoading(data);
        deleteOperation(
          {
            url: `/api/marketDetail/?orgId=${localStorage.getItem(
              "orgId"
            )}&marketDetailId=${marketDetailId}&serviceId=${serviceId}`,
            method: "DELETE",
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
              setDeleteLoading(false);
            }

            if (data.error) {
              toast.error(data.error);
              setDeleteLoading(false);
            }

            FillDetail();
          },
          (error) => {
            toast.error(error);
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const { sendRequest: getMarketData } = useHttp();

  const FillDetail = () => {
    getMarketData(
      {
        url: `/api/marketDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getMarketData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const handleSearch = (e) => {
    var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.areaName.toLowerCase().includes(filetrtext) ||
        item.stationName.toLowerCase().includes(filetrtext) ||
        item.areaCode.toLowerCase().includes(filetrtext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "450px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (id) => {
    if (id) {
      getMarketData(
        {
          url: `/api/marketDetail/?marketDetailId=${id}&orgId=${localStorage.getItem(
            "orgId"
          )}`,
        },
        (res) => {
          if (res) {
            setSelectedData(res);
          }
        }
      );
    }
    setIsModalOpen(true);
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Market Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Doc No: {selectedData.docNo}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Market Date: {selectedData.marketDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Area Name: {selectedData.areaName}</p>
              <p className="col-md-6">
                Store Name : {selectedData.warehouseName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Market Name: {selectedData.marketName}</p>
            </div>
            <h5 className="card-title">Vehicle Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Vehicle Code</th>
                  <th>Vehicle Name</th>
                  <th>Driver Name</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.vehicleData &&
                  selectedData.vehicleData.map((x, i) => (
                    <tr key={i}>
                      <td>{x.VehicleCode}</td>
                      <td>{x.vmeNo}</td>
                      <td>{x.assignedPersonDriverName}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <h5 className="card-title">Staff Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Employee Id</th>
                  <th>Employee Name</th>
                  <th>Phone No</th>
                  <th>Work Allocation</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.staffData &&
                  selectedData.staffData.map((x, i) => (
                    <tr key={i}>
                      <td>{x.employeeId}</td>
                      <td>{x.employeeName}</td>
                      <td>{x.phoneNo}</td>

                      <td>{x.workAllocation}</td>
                    </tr>
                  ))}
              </tbody>
            </table>{" "}
            <h5 className="card-title">Market Team Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Employee Id</th>
                  <th>Employee Name</th>
                  <th>Phone No</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.teamData &&
                  selectedData.teamData.map((x, i) => (
                    <tr key={i}>
                      <td>{x.employeeId}</td>
                      <td>{x.employeeName}</td>
                      <td>{x.phoneNo}</td>
                    </tr>
                  ))}
              </tbody>
            </table>{" "}
            {/**/}
          </div>
        )}
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-9">
            <label className="card-title  my-3">
              {" "}
              &nbsp; &nbsp;Market Details{" "}
            </label>{" "}
          </div>

          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2"
              onClick={() => {
                addForm(true);
                props.sId(serviceId || 0);
                props.update(false);
              }}
            >
              Add Market Details
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Doc No</th>
                            <th>Area Name</th>
                            <th>Store Name</th>
                            <th>Market Name</th>
                            <th>View</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.marketDate}</td>
                                <td>{x.docNo}</td>
                                <td>{x.areaName}</td>
                                <td>{x.warehouseName}</td>
                                <td>{x.marketName}</td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x.marketDetailId)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  {deleteLoading === x ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        handleDelete(e, x.marketDetailId)
                                      }
                                      className="btn"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MarketDetailsList;
